<div class="container-fluid px-0">
  <div class="row gx-0 px-2 py-3 align-items-center">
    <div class="col"><h2 class="mb-0">Portfolios</h2></div>
    @if (isAdmin) {
      <div class="col-auto">
        <a matFab extended class="narrow-button" routerLink="." (click)="newPortfolio()">
          Add New
          <mat-icon>add_circle</mat-icon>
        </a>
      </div>
    }
  </div>
  <div appFillHeight class="ps-2">
    <div class="row gx-0 px-2 gx-0 pb-2 scrollbar" >
      @for (portfolio of portfolios; track $index) {
        <mat-card [class.selected]="portfolio.id === _portfolioService.selectedPortfolio()"
        appearance="outlined" class="mt-1 pointer" (click)="selectPortfolio(portfolio.id)">
          <mat-card-header class="p-2">
            <div class="row w-100 gx-0 align-items-center">
              <div class="col">
                <mat-card-title>{{ portfolio.name }}</mat-card-title>
                <mat-card-subtitle>{{ portfolio.description }}</mat-card-subtitle>
              </div>
              @if (isAdmin) {
                <div class="col-auto">
                  <div class="btn-group" role="group">
                    <button class="btn-row mat-ctrlkey-midnight me-1" matMiniFab aria-label="Edit Portfolio" (click)="editPortfolio(portfolio); $event.stopPropagation();" matTooltip="Edit Portfolio">
                      <mat-icon>edit_note</mat-icon>
                    </button>
                    <button class="btn-row mat-ctrlkey-orange me-1" matMiniFab aria-label="Delete Portfolio" (click)="deletePortfolio(portfolio); $event.stopPropagation();" matTooltip="Delete Portfolio">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </mat-card-header>
          <mat-card-content>
            <ul class="ps-3">
              @for (proj of portfolioMap.get(portfolio.id); track $index) {
                <li>{{ proj }}</li>
              }
            </ul>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>